import React from 'react';
import './SubCategoryGrid.css';

const SubCategoryGrid = ({ subCategories = [], onSelect }) => {
  
  return (
    <div className="subcat-grid">
      {subCategories.map(({ id, name, image, Icon }) => (
        <button key={id} className="subcat-card" onClick={() => onSelect(id)}>
          <div className="subcat-thumb"
            style={{ backgroundImage: `url(${image})` }}
            aria-label={name}
          />
          <span className="subcat-name">{name}</span>
          {Icon && <Icon className="subcat-icon" />}
        </button>
      ))}
    </div>
  );
};

export default SubCategoryGrid;
